import { FC, useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import Breadcrumb from '../../Components/Breadcrumb';
import ClientService from './service';

import {
    Link, useNavigate
} from "react-router-dom";
import { useTranslation } from 'react-i18next';

const ClientList: FC = () => {  
    let idToModInit: any = null;
    const [ clients, setClients ] = useState( [] );
    const [ idToMod, setIdToMod ] = useState(idToModInit);
    const [ loading, setLoading ] = useState(false);
    const clientService = new ClientService();

    const navigate = useNavigate();
    const { t } = useTranslation(); 
    let editAgent = (id: Number): void => {
        setIdToMod(id);
        setLoading(true);
        navigate('/agent/edit/'+id.toString());
        setLoading(false);
    }

    const getClients = () => {
        setLoading(true);
        clientService.getClients().then(async function (response: any) {
            console.log(response);
            setClients(response.data);
            setLoading(false); 
        })
          .catch(function (error: any) {
            console.log(error);
            setLoading(false); 
        });
    }

    useEffect( function() { 
        getClients();
    }, []);

    const columns = [
        {
            name: `${t('Prénom')}`,
            selector: (row: any) => row.prenomClient,
        },
        {
            name: `${t('Nom')}`,
            selector: (row: any) => row.nomClient,
        },
        {
            name: `${t('Contact')}`,
            selector: (row: any) => row.contactClient,
        },
        {
            name: `${t('Adresse')}`,
            selector: (row: any) => row.adresseClient?.addresseLineOne,
        },
        {
            name: "Options", 
            selector: (row: any) => (
                <>
                    <button type="button" onClick={event => {
                            navigate('/client/edit/'+row.id.toString());
                        }}
                            className="btn waves-effect waves-light btn-success">
                                <span className="" style={{ fontSize: "1em" }} >
                                    <i className="icon-pencil"></i></span>
                    </button>
                    <button type="button" onClick={event => {  }}
                        className="btn waves-effect waves-light btn-danger"> 
                                <span className="" style={{ fontSize: "1em" }} >
                                <i className="icon-trash"></i></span>
                            
                    </button> 
                </>
            )
        }
    ];
    

    return (
            <> 
                <Breadcrumb />
 
                <div className="container-fluid">
    
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="btn-list">
                                    <button type="button" onClick={ event => getClients() }
                                        className="btn waves-effect waves-light btn-danger">
                                            { t('Actualiser') }
                                        </button>
                                        <Link type="button" to="/client/create"
                                            className="btn waves-effect waves-light btn-primary">
                                            { t('Ajouter un client') }    
                                        </Link>
                                    </div>
                                    
                                    <br />
                                    <br />
                                    {/* <h4 className="card-title">Zero Configuration</h4>
                                    <h6 className="card-subtitle">DataTables has most features enabled by default, so all you
                                        need to do to use it with your own tables is to call the construction
                                        function:<code> $().DataTable();</code>. You can refer full documentation from here
                                        <a href="https://datatables.net/">Datatables</a></h6> */}
                                    <div className="table-responsive">
                                        <DataTable
                                            responsive={true}
                                            className="table table-striped table-bordered"
                                            columns={columns}
                                            data={clients}
                                            progressPending={loading}
                                            pagination
                                        />
                                        </div>
                                    </div>
                                </div> 
                        </div> 
                    </div>

                </div>   
            </>                   

    );
}

export default ClientList